import styled from "styled-components";
import { TableContent } from "components/Table/style";
export const Table = styled(TableContent)`
  width: 100%;
  th,
  td {
    :first-child {
      text-align: right;
    }
  }
`;
